// RxJS
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  selectCompaniesInitWaitingMessage,
  selectCompaniesInStore,
  selectCompaniesPageLoading,
} from './company.selectors';

// Selectors

export class CompaniesDatasource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();
    this.loading$ = this.store.pipe(select(selectCompaniesPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectCompaniesInitWaitingMessage)
    );

    this.store
      .pipe(select(selectCompaniesInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
